import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import {
  fetchCardsWithListNames,
  fetchLists,
} from "../../redux/reducers/trello/slice";

export default function ListSelect({ listName, setListName }) {
  const dispatch = useDispatch();
  const {
    lists,
    listsLoading,
    listsFetched,
    cards,
    cardsLoading,
    cardsFetched,
  } = useSelector((state) => state.trello);

  const handleSelectOption = (selectedOption) => {
    if (listName.includes(selectedOption)) {
      setListName(listName.filter((name) => name !== selectedOption));
    } else {
      setListName([...listName, selectedOption]);
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: { opacity: 1, y: 0 },
  };

  React.useEffect(() => {
    if (!lists.length && !listsLoading && !listsFetched) {
      dispatch(fetchLists());
    }
  }, [dispatch, lists, listsLoading, listsFetched]);

  React.useEffect(() => {
    if (!cards.length && !cardsLoading && !listsFetched && !cardsFetched) {
      dispatch(fetchCardsWithListNames());
    }
  }, [dispatch, cards, cardsLoading, listsFetched, cardsFetched]);

  return (
    <FormControl sx={{ mt: 2, width: "100%" }}>
      <InputLabel shrink htmlFor="select-multiple-native">
        Lists
      </InputLabel>
      <Select
        multiple
        native     
        value={listName}       
        label="Lists"
        inputProps={{
          id: "select-multiple-native",
          paddingRight: 0,
          sx: {            
            overflowY: "scroll",
            "&::-webkit-scrollbar": {
              width: "12px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#008c23",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#008c2370",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#e1e1e1",
            },
            "&::-webkit-scrollbar-button": {
              display: "none",
            },
          },
        }}
        disabled={listsFetched && !lists.length}
      >
        {listsFetched &&
          lists.length > 0 &&
          lists.map((list, index) => (
            <motion.option
              key={list.name}
              value={list.value}
              variants={itemVariants}
              initial="hidden"
              animate="visible"
              transition={{ delay: index * 0.1 }}
              onClick={() => handleSelectOption(list.value)}
            >
              {list.name}
            </motion.option>
          ))}
        {listsFetched && lists.length === 0 && (
          <motion.option
            value=""
            variants={itemVariants}
            initial="hidden"
            animate="visible"
          >
            No lists found
          </motion.option>
        )}
      </Select>
    </FormControl>
  );
}
